@let cardTitle = titleText;
@if (!opened) {
  @let lines = summary.length > 1 || !!summary[0]?.composeLines;
  <ng-template #summaryItem let-item>
    <span class="group-card__line-item" [class.group-card__line-item--incomplete]="item.incomplete">
      <span class="group-card__line-item-label">{{ item.label }}</span>
      <app-source-pieces
        [fixedValue]="item.fixed ? item.value : null"
        [pieces]="item.composeLines ? item.composeLines.mark : item.pieces"
      ></app-source-pieces>
    </span>
  </ng-template>
  <ng-template #composeLineRows let-item>
    @if (item.composeLines; as composeLines) {
      @for (line of composeLines.lines; track $index) {
        <span class="group-card__line-source group-card__line-source--compose-line">
          <span class="group-card__line-item">
            <span class="group-card__line-item-label">
              {{ 'TRANS__IMPORT__MAPPING__COMPOSE_LINE' | translate: {number: $index + 1} }}
            </span>
            <app-source-pieces [pieces]="line" [keepColumns]="true"></app-source-pieces>
          </span>
        </span>
      }
      @if (composeLines.moreLines) {
        <span class="group-card__line-source group-card__line-source--compose-line group-card__line-more">
          {{ 'TRANS__IMPORT__MAPPING__MORE_LINES' | translate: {count: composeLines.moreLines} }}
        </span>
      }
    }
  </ng-template>
  <div
    class="group-card group-card--collapsed"
    [class.group-card--lines]="lines"
    [class.group-card--lines-valued]="lines && previewRow !== null"
  >
    <span class="group-card__line-label">{{ cardTitle }}</span>
    <span class="group-card__line-source">
      @if (summary[0]; as item) {
        <ng-container *ngTemplateOutlet="summaryItem; context: {$implicit: item}"></ng-container>
      }
    </span>
    @let warnText = incomplete
      ? (missingMembers.length
        ? ('TRANS__IMPORT__GROUP_CARD__MISSING_MEMBERS' | translate: {fields: missingMemberLabels})
        : ('TRANS__IMPORT__LINE__INCOMPLETE' | translate))
      : warnsUnknownPlaceholders ? ('TRANS__IMPORT__UNKNOWN_PLACEHOLDER' | translate) : null;
    @if (warnText) {
      <span class="group-card__line-warn" [title]="warnText">
        <mat-icon aria-hidden="true">warning_amber</mat-icon>
        <span class="group-card__line-warn-text">{{ warnText }}</span>
      </span>
    }
    @if (previewRow !== null) {
      <span class="group-card__line-value">
        @if (preview) {
          <app-row-value [values]="lineValues(0)" [pending]="previewPending"></app-row-value>
        }
      </span>
    }
    <button
      mat-icon-button
      type="button"
      class="group-card__line-open"
      (click)="openedChange.emit(true)"
      [matTooltip]="'TRANS__IMPORT__LINE__EDIT' | translate: {field: cardTitle}"
      [attr.aria-label]="'TRANS__IMPORT__LINE__EDIT' | translate: {field: cardTitle}"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      class="group-card__line-remove"
      (click)="removeGroup.emit()"
      [matTooltip]="'TRANS__IMPORT__GROUP_CARD__REMOVE' | translate"
      [attr.aria-label]="'TRANS__IMPORT__GROUP_CARD__REMOVE' | translate"
    >
      <mat-icon>delete_outline</mat-icon>
    </button>
    @for (item of summary; track $index) {
      @if (!$first) {
        <span class="group-card__line-source">
          <ng-container *ngTemplateOutlet="summaryItem; context: {$implicit: item}"></ng-container>
        </span>
        @if (previewRow !== null) {
          <span class="group-card__line-value">
            @if (preview) {
              <app-row-value [values]="lineValues($index)" [pending]="previewPending"></app-row-value>
            }
          </span>
        }
      }
      <ng-container *ngTemplateOutlet="composeLineRows; context: {$implicit: item}"></ng-container>
    }
  </div>
} @else {
  <mat-card appearance="outlined" class="group-card group-card--opened">
    <mat-card-content>

      <div class="group-card__header">
        <span class="group-card__title bold">{{ cardTitle }}</span>
        <span class="group-card__editing">{{ 'TRANS__IMPORT__LINE__EDITING' | translate }}</span>
        <div class="group-card__header-actions">
          <button
            mat-icon-button
            type="button"
            class="group-card__remove"
            (click)="removeGroup.emit()"
            [attr.aria-label]="'TRANS__IMPORT__GROUP_CARD__REMOVE' | translate"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>

      <div class="group-card__concepts">
        @for (h of descriptor.header; track h.key) {
          <app-concept-picker
            [label]="h.label"
            [required]="h.required"
            [options]="h.options"
            [control]="model.headerControls[h.key]"
          ></app-concept-picker>
        }
      </div>

      @if (model.onlyWhenMappedControl) {
        <mat-checkbox [formControl]="model.onlyWhenMappedControl" class="group-card__only-when-mapped">
          {{ 'TRANS__IMPORT__ADMIN_EVENT_ONLY_WHEN_MAPPED' | translate }}
        </mat-checkbox>
      }

      @if (model.createMissingControl; as createMissing) {
        <mat-checkbox [formControl]="createMissing" class="group-card__create-missing">
          {{ 'TRANS__IMPORT__GROUP_CARD__CREATE_MISSING' | translate }}
        </mat-checkbox>
        @if (createMissing.value && model.createMissingParentControl; as parentControl) {
          <div class="group-card__concepts">
            <app-concept-picker
              label="TRANS__IMPORT__GROUP_CARD__CREATE_MISSING_PARENT"
              [required]="false"
              [options]="descriptor.createMissingParentOptions ?? []"
              [control]="parentControl"
            ></app-concept-picker>
          </div>
        }
      }

      <div class="group-card__members">
        @if (model.members.length) {
          <div class="group-card__member-row group-card__member-head" aria-hidden="true">
            <span>{{ 'TRANS__IMPORT__GROUP_CARD__COL_FIELD' | translate }}</span>
            <span>{{ 'TRANS__IMPORT__VALUE_SOURCE' | translate }}</span>
            <span>{{ 'TRANS__IMPORT__GROUP_CARD__COL_VALUE' | translate }}</span>
          </div>
        }
        @for (row of model.members; track row.id) {
          <ng-container
            [ngTemplateOutlet]="memberRow"
            [ngTemplateOutletContext]="{row: row, removable: true}"
          ></ng-container>
        }

        @if (!model.members.length && !model.subBlocks.length) {
          <p class="group-card__hint">{{ 'TRANS__IMPORT__GROUP_CARD__NO_FIELDS' | translate }}</p>
        }

        @if (missingMembers.length) {
          <p class="group-card__warn group-card__missing-members">
            {{ 'TRANS__IMPORT__GROUP_CARD__MISSING_MEMBERS' | translate: {fields: missingMemberLabels} }}
          </p>
        }
      </div>

      @if (availableMemberFields.length) {
        <button mat-stroked-button type="button" [matMenuTriggerFor]="addFieldMenu" class="group-card__add-field">
          <mat-icon>add</mat-icon>
          <span class="bold uppercase">{{ 'TRANS__IMPORT__GROUP_CARD__ADD_FIELD' | translate }}</span>
        </button>
        <mat-menu #addFieldMenu="matMenu">
          @for (def of availableMemberFields; track def.fieldId) {
            <button mat-menu-item type="button" (click)="addMember.emit(def.fieldId)">
              {{ def.label }}
            </button>
          }
        </mat-menu>
      }

      <!-- Repeatable sub-blocks: a history event's named parties and places,
           each its own role / status + one named_id / place_id member. -->
      @for (def of descriptor.subBlocks; track def.kind) {
        <div class="group-card__sub-blocks">
          @for (sub of subBlockRows(def.kind); track sub.key) {
            <div class="group-card__sub-block">
              <div class="group-card__sub-block-head">
                <span class="group-card__sub-block-title bold">
                  {{ def.titleKey | translate }} {{ $index + 1 }}
                </span>
                <button
                  mat-icon-button
                  type="button"
                  (click)="removeSubBlock.emit(sub)"
                  [attr.aria-label]="'TRANS__IMPORT__GROUP_CARD__REMOVE_SUB_BLOCK' | translate"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div class="group-card__concepts">
                @for (h of def.header; track h.key) {
                  <app-concept-picker
                    [label]="h.label"
                    [required]="h.required"
                    [options]="h.options"
                    [control]="sub.headerControls[h.key]"
                  ></app-concept-picker>
                }
                @if (sub.target; as target) {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="group-card__object-type">
                    <mat-label>{{ 'TRANS__IMPORT__GROUP_CARD__OBJECT_TYPE' | translate }}</mat-label>
                    <mat-select [formControl]="target.objectTypeControl" (selectionChange)="onObjectTypeChanged(sub)">
                      @for (objectType of objectTypes; track objectType) {
                        <mat-option [value]="objectType">{{ objectTypeLabel(objectType) | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (showTypePicker(sub)) {
                    <app-concept-picker
                      (focusin)="requestTypeOptions()"
                      [label]="typePickerLabel(target.objectTypeControl.value)"
                      [required]="true"
                      [options]="typeOptions[target.objectTypeControl.value]"
                      [control]="target.typeIdControl"
                    ></app-concept-picker>
                  }
                }
              </div>
              <ng-container
                [ngTemplateOutlet]="memberRow"
                [ngTemplateOutletContext]="{row: sub.member, removable: false}"
              ></ng-container>
            </div>
          }
          <button mat-stroked-button type="button" (click)="addSubBlock.emit(def)" class="group-card__add-field">
            <mat-icon>add</mat-icon>
            <span class="bold uppercase">{{ def.addLabelKey | translate }}</span>
          </button>
        </div>
      }

      <div class="group-card__line-actions">
        <button mat-flat-button color="primary" type="button" (click)="openedChange.emit(false)">
          <span class="bold uppercase">{{ 'TRANS__IMPORT__LINE__DONE' | translate }}</span>
        </button>
      </div>

    </mat-card-content>
  </mat-card>
}

<ng-template #memberRow let-row="row" let-removable="removable">
  @let kind = sourceKind(row);
  <div class="group-card__member">
    <div class="group-card__member-row">
      <span class="group-card__member-label">{{ memberDef(row)?.label }}</span>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="group-card__source-kind">
        <mat-select
          [value]="kind"
          (selectionChange)="onSourceKindChange(row, $event.value)"
          [aria-label]="'TRANS__IMPORT__VALUE_SOURCE' | translate"
          [aria-describedby]="'group-member-source-hint-' + row.id"
        >
          @for (option of sourceKinds(row); track option) {
            <mat-option
              [value]="option"
              [matTooltip]="sourceKindTooltips[option] | translate"
              matTooltipPosition="right"
            >{{ sourceKindLabels[option] | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="group-card__value">
        @if (memberDef(row)?.concept) {
          <mat-button-toggle-group
            [formControl]="row.valueTypeControl"
            class="group-card__source-toggle"
            [attr.aria-label]="'TRANS__IMPORT__GROUP_CARD__VALUE_TYPE' | translate"
          >
            <mat-button-toggle
              value="name"
              [matTooltip]="'TRANS__IMPORT__GROUP_CARD__VALUE_TYPE__NAME_TOOLTIP' | translate"
            >
              {{ 'TRANS__IMPORT__GROUP_CARD__VALUE_TYPE__NAME' | translate }}
            </mat-button-toggle>
            <mat-button-toggle
              value="kulturnav_uuid"
              [matTooltip]="'TRANS__IMPORT__GROUP_CARD__VALUE_TYPE__KULTURNAV_UUID_TOOLTIP' | translate"
            >
              {{ 'TRANS__IMPORT__GROUP_CARD__VALUE_TYPE__KULTURNAV_UUID' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        }

        @switch (kind) {
          @case ('column') {
            <app-column-template-input
              class="group-card__value-input"
              [control]="row.templateControl"
              [columns]="columns"
            ></app-column-template-input>
          }
          @case ('lookup') {
            <app-lookup-source-fields
              class="group-card__lookup-fields"
              [grid]="true"
              [row]="row"
              [lookups]="lookups"
              [lookupColumns]="lookupColumns"
              [lookupColumnsLoading]="lookupColumnsLoading"
            ></app-lookup-source-fields>
          }
          @case ('compose') {
            <!-- The lines, under the row. -->
          }
          @default {
            @if (isKulturNavUuid(row)) {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="group-card__value-input">
                <mat-label>{{ 'TRANS__IMPORT__GROUP_CARD__FIXED_KULTURNAV_UUID' | translate }}</mat-label>
                <input matInput [formControl]="row.constantControl">
              </mat-form-field>
            } @else if (memberDef(row)?.concept && subBlockKindOfMember(row) === 'place') {
              <app-place-select
                class="group-card__value-input"
                [formControl]="row.conceptControl"
                label="TRANS__IMPORT__GROUP_CARD__FIXED_PLACE"
              ></app-place-select>
            } @else if (memberDef(row)?.concept) {
              <app-named-party-select
                class="group-card__value-input"
                [formControl]="row.conceptControl"
                [objectType]="namedObjectTypeOf(row)"
                label="TRANS__IMPORT__GROUP_CARD__FIXED_NAMED_PARTY"
              ></app-named-party-select>
            } @else {
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="group-card__value-input">
                <mat-label>{{ 'TRANS__IMPORT__GROUP_CARD__FIXED_VALUE' | translate }}</mat-label>
                <input matInput [formControl]="row.constantControl">
              </mat-form-field>
            }
          }
        }
      </div>

      @if (removable) {
        <button
          mat-icon-button
          type="button"
          (click)="removeMember.emit(row)"
          [attr.aria-label]="'TRANS__IMPORT__GROUP_CARD__REMOVE_FIELD' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      <p class="group-card__hint group-card__source-hint" [id]="'group-member-source-hint-' + row.id">
        {{ sourceKindTooltips[kind] | translate }}
      </p>
    </div>

    @if (kind === 'compose') {
      <app-compose-field
        [rows]="row.composeRows"
        [columns]="columns"
        (addLine)="addComposeLine.emit({row: row})"
        (removeLine)="removeComposeLine.emit({row: row, line: $event})"
        (reorder)="reorderComposeLines.emit({row: row, lines: $event})"
      ></app-compose-field>
    }

    @let rowValues = previewValuesOf(row);
    @if (rowValues !== undefined) {
      <p class="group-card__row-value-line">
        <app-row-value [values]="rowValues" [labelRow]="previewRow" [pending]="previewPending"></app-row-value>
      </p>
    }
    @let unknown = unknownPlaceholders(row);
    @if (unknown.length) {
      <p class="group-card__warn">
        {{ 'TRANS__IMPORT__UNKNOWN_PLACEHOLDER' | translate }}:
        {{ unknown.join(', ') }}
      </p>
    }
  </div>
</ng-template>
